import { Academy } from "../icons/academy.tsx"
import { Analytics } from "../icons/analytics"
import { Archive } from "../icons/archive"
import { Bell } from "../icons/bell"
import { Calendar } from "../icons/calendar"
import { Check } from "../icons/check.tsx"
import { Customers } from "../icons/customers"
import { Delete } from "../icons/delete"
import { Dollar } from "../icons/dollar.tsx"
import { Download } from "../icons/download.tsx"
import { Edit } from "../icons/edit"
import { Files } from "../icons/files.tsx"
import { Filter } from "../icons/filter"
import { Guide } from "../icons/guide.tsx"
import { Handshake } from "../icons/handshake.tsx"
import { Home } from "../icons/home"
import { Leads } from "../icons/leads"
import { Logout } from "../icons/logout"
import { Magic } from "../icons/magic.tsx"
import { Map } from "../icons/map.tsx"
import { Office } from "../icons/office"
import { Palette } from "../icons/palette"
import { Privacy } from "../icons/privacy"
import { Projects } from "../icons/projects"
import { Report } from "../icons/report.tsx"
import { Restore } from "../icons/restore"
import { Settings } from "../icons/settings"
import { Share } from "../icons/share.tsx"
import { Shield } from "../icons/shield"
import { Signature } from "../icons/signature.tsx"
import { Subcontractors } from "../icons/subcontractors"
import { Upload } from "../icons/upload.tsx"
import { User } from "../icons/user"
import { Users } from "../icons/users"
import { VerticalDots } from "../icons/vertical-dots.tsx"

export const svg = {
  Analytics,
  Home,
  Leads,
  Magic,
  Customers,
  Edit,
  Archive,
  Projects,
  Report,
  Subcontractors,
  Users,
  Settings,
  Logout,
  Map,
  User,
  Shield,
  Bell,
  Privacy,
  Office,
  Dollar,
  Palette,
  Calendar,
  Files,
  Signature,
  Filter,
  Delete,
  Restore,
  Share,
  Handshake,
  VerticalDots,
  Upload,
  Download,
  Check,
  Guide,
  Academy
} as const
